import { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { CalendarIcon, ArrowLinkIcon } from './icons';

function DashboardMockup() {
  return (
    <motion.div
      initial={{ opacity: 0, y: 16 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay: 0.2 }}
      style={{ position: 'relative', width: '100%', maxWidth: 640 }}
    >
      <img
        src="/landing/dashboardmockup.png"
        alt="Sleengshort dashboard preview"
        width={1000}
        height={905}
        style={{ width: '100%', height: 'auto', objectFit: 'contain' }}
        loading="eager"
      />
    </motion.div>
  );
}

export function Hero() {
  const sectionRef = useRef(null);
  const { scrollYProgress } = useScroll({ target: sectionRef, offset: ['start start', 'end start'] });
  const parallaxOpacity = useTransform(scrollYProgress, [0, 1], [1, 0.25]);
  const parallaxY = useTransform(scrollYProgress, [0, 1], [0, -70]);
  const parallaxScale = useTransform(scrollYProgress, [0, 1], [1, 0.94]);

  return (
    <section ref={sectionRef} style={{ background: 'linear-gradient(136.58deg, rgba(255,255,255,0.6) 21.5%, rgba(1,78,210,0.08) 94.4%)', paddingTop: 24 }}>
      <motion.div style={{ opacity: parallaxOpacity, y: parallaxY, scale: parallaxScale, maxWidth: 1400, margin: '0 auto', padding: '48px 24px 72px', display: 'flex', alignItems: 'center', gap: 40, flexWrap: 'wrap' }}>
        <div style={{ flex: '1 1 480px', minWidth: 320 }}>
          <motion.div
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            style={{
              display: 'inline-flex', alignItems: 'center', gap: 8, height: 32, padding: '0 16px',
              background: '#f0f9f6', borderRadius: 23, marginBottom: 24,
            }}
          >
            <span style={{ width: 8, height: 8, borderRadius: '50%', background: '#2ca342', flexShrink: 0 }} />
            <span style={{ fontSize: 13, fontFamily: 'Inter, sans-serif', fontWeight: 500, color: '#000' }}>#1 Trusted SMS Platform in Nigeria</span>
          </motion.div>

          <h1 style={{ margin: 0, fontFamily: 'Inter, sans-serif', fontWeight: 800, fontSize: 'clamp(36px, 5.5vw, 64px)', lineHeight: 1.08, color: '#152752' }}>
            <motion.span initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5, delay: 0.08 }} style={{ display: 'block' }}>
              Reach More.
            </motion.span>
            <motion.span initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5, delay: 0.16 }} style={{ display: 'block' }}>
              Engage Better.
            </motion.span>
            <motion.span initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5, delay: 0.24 }} style={{ display: 'block', color: '#014ed2' }}>
              Grow Faster<span style={{ color: '#ef2c2d' }}>.</span>
            </motion.span>
          </h1>

          <motion.p
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.32 }}
            style={{ margin: '24px 0 32px', fontFamily: 'Inter, sans-serif', fontWeight: 500, fontSize: 18, color: '#4c5876', lineHeight: 1.5, maxWidth: 460 }}
          >
            Sleengshort makes business communication simple with reliable SMS, Voice, WhatsApp &amp; more.
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.4 }}
            style={{ display: 'flex', gap: 14, flexWrap: 'wrap' }}
          >
            <a href="/login" style={{ textDecoration: 'none' }}>
              <motion.span
                whileHover={{ opacity: 0.9 }}
                whileTap={{ scale: 0.97 }}
                style={{
                  height: 51, padding: '0 24px', background: '#014ed2', borderRadius: 7,
                  display: 'flex', alignItems: 'center', gap: 10, fontSize: 13, fontFamily: 'Inter, sans-serif',
                  fontWeight: 600, color: '#fff',
                }}
              >
                <CalendarIcon />
                Book a Demo
              </motion.span>
            </a>
            <a href="mailto:support@sleengshort.com" style={{ textDecoration: 'none' }}>
              <motion.span
                whileHover={{ backgroundColor: '#f8faff' }}
                whileTap={{ scale: 0.97 }}
                style={{
                  height: 51, padding: '0 24px', border: '1px solid #cecece', borderRadius: 7,
                  display: 'flex', alignItems: 'center', gap: 10, fontSize: 13, fontFamily: 'Inter, sans-serif',
                  fontWeight: 600, color: '#014ed2',
                }}
              >
                Talk to Sales
                <ArrowLinkIcon />
              </motion.span>
            </a>
          </motion.div>
        </div>

        <div style={{ flex: '1 1 560px', minWidth: 380, display: 'flex', justifyContent: 'center' }}>
          <DashboardMockup />
        </div>
      </motion.div>
    </section>
  );
}
